export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/infographic_design.3cd4bf6.svg";